import { useState } from 'react';
import { SectionHeading } from './SectionHeading';
import { Typography } from './Typography';
import { Button } from './Button';
import { ValueBox } from './ValueBox';
import { company } from '../content/site';
import styles from './BriefSection.module.css';
export function BriefSection() {
  const [sites, setSites] = useState(3);
  const [items, setItems] = useState(1000);
  const [weeks, setWeeks] = useState(4);
  const format = new Intl.NumberFormat('ru-RU');
  const plural = (n: number, forms: string[]) =>
    forms[
      new Intl.PluralRules('ru').select(n) === 'one'
        ? 0
        : new Intl.PluralRules('ru').select(n) === 'few'
          ? 1
          : 2
    ];
  const body = `Здравствуйте! Нужна инвентаризация.\nКоличество площадок: ${sites}.\nОриентировочное количество позиций: ${items}.\nЖелаемый срок: ${weeks} нед.\n\nКомпания:\nКонтактное лицо:\nРасположение объектов:`;
  const email = `mailto:${company.email}?subject=${encodeURIComponent('Запрос коммерческого предложения — инвентаризация')}&body=${encodeURIComponent(body)}`;
  return (
    <section className={styles.section}>
      <SectionHeading eyebrow="Ваш проект" title="У каждой задачи свой масштаб" />
      <div className={styles.panel}>
        <div className={styles.controls}>
          <div className={styles.control}>
            <div className={styles.label}>
              <Typography as="label" variant="fieldLabel" htmlFor="brief-sites">
                Количество площадок
              </Typography>
              <ValueBox value={sites} />
            </div>
            <input
              id="brief-sites"
              type="range"
              min="1"
              max="30"
              value={sites}
              onChange={(e) => setSites(Number(e.target.value))}
            />
          </div>
          <div className={styles.control}>
            <div className={styles.label}>
              <Typography as="label" variant="fieldLabel" htmlFor="brief-items">
                Позиций для проверки
              </Typography>
              <ValueBox value={format.format(items)} />
            </div>
            <input
              id="brief-items"
              type="range"
              min="100"
              max="50000"
              step="100"
              value={items}
              onChange={(e) => setItems(Number(e.target.value))}
            />
            <Typography variant="small" tone="muted">
              Ориентировочный объём ТМЗ или основных средств.
            </Typography>
          </div>
          <div className={styles.control}>
            <div className={styles.label}>
              <Typography as="label" variant="fieldLabel" htmlFor="brief-weeks">
                Желаемый срок, недель
              </Typography>
              <ValueBox value={weeks} />
            </div>
            <input
              id="brief-weeks"
              type="range"
              min="1"
              max="24"
              value={weeks}
              onChange={(e) => setWeeks(Number(e.target.value))}
            />
          </div>
        </div>
        <div className={styles.result}>
          <div aria-live="polite" aria-atomic="true">
            <Typography
              as="h3"
              variant="title"
            >{`${sites} ${plural(sites, ['площадка', 'площадки', 'площадок'])}. ${format.format(items)} ${plural(items, ['позиция', 'позиции', 'позиций'])}. ${weeks} ${plural(weeks, ['неделя', 'недели', 'недель'])} на вашу задачу.`}</Typography>
          </div>
          <Typography tone="muted">
            Подготовим предложение с учётом ваших объектов, объёма и сроков. Финальный план
            согласуем после обсуждения деталей.
          </Typography>
          <Button href={email} fullWidth>
            Запросить предложение
          </Button>
          <Typography variant="small" tone="muted">
            Откроется почтовая программа с описанием проекта.
          </Typography>
        </div>
      </div>
    </section>
  );
}
